import Resource from '@/services/resources/common';

export default class Cookie extends Resource {
  constructor(entrypoint = '/cookies', alias = 'Cookie') {
    super(entrypoint, alias);
  }
}
